import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'
import eduWebConfig from './modules/eduwebconfig'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex);
let state = {
    questionInfo: {},
    isNewFirstInterView:0 // 初次 访谈记录表  1:新访谈记录表 0:旧的访谈记录表
}
const store = new Vuex.Store({
    modules: {
        user,
        permission,
        eduWebConfig
    },
    state,
    getters,
    mutations

})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js